module.exports = "/_next/static/images/programming-hub-thumbnail-d9f1ec601b586c7c942b54195d3cf432.webp";